import { compact } from 'lodash'
import { useEffect } from 'react'
import { default as ComboMultiSelect } from 'app/components/ui/combo/combo-multi-select'
import { FilterObject } from 'app/filter.utils'

export default function MultiSelectFilter({
  filter,
  value,
  onValueChange,
  onArrayFilterChange,
}: {
  filter: FilterObject
  value?: string[]
  onValueChange: (val: string[]) => void
  onArrayFilterChange?: React.Dispatch<React.SetStateAction<any>>
}) {
  useEffect(() => {
    onArrayFilterChange?.(value?.length === 1 ? value?.[0] : ``)
  }, [value])
  return (
    <ComboMultiSelect
      name="filterMulti"
      inputClassName="!h-8 cursor-pointer rounded-lg border border-default !px-2 !text-body-sm !pt-3"
      optionsContainerClassName="max-h-[480px]"
      values={
        filter.useAsterisk && (value as Array<string>)?.includes(`*`)
          ? [{ name: `All`, id: `*`, value: `*` }]
          : compact(
              filter.options?.map((option) =>
                (value as Array<string>)?.includes(option.value! as string) ? option : undefined,
              ),
            )
      }
      options={filter.options ?? []}
      onChange={(options) => {
        onValueChange(options?.map((option) => option.value! as string))
      }}
      deselectAllOptions={filter.useAsterisk ? [{ name: `All`, id: `*`, value: `*` }] : undefined}
      disabled={filter.readOnly}
      enableDeselectAllOption
    />
  )
}
